/* WHITESPACE_VALUE is used to fill whitespace present in user-inputed `value` when creating id for TabsItem and TabsPanel */
const WHITESPACE_VALUE = '-';

export { WHITESPACE_VALUE };
